import type {LngLatBoundsLike} from 'mapbox-gl';

export const BD_GEOGRAPHIC_GERMANY_BBOX: LngLatBoundsLike = [
  [15.0169958839, 47.3024876979],
  [5.98865807458, 54.983104153]
];
